import { render } from "./add.vue?vue&type=template&id=e5d75acc"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"

import "./add.vue?vue&type=style&index=0&id=e5d75acc&lang=scss"
script.render = render

export default script